import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Redirect } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import SelectClass from "../ChildComponent/SelectClass";

const API_BASE = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const MdlSelectSingleServiceStudent = ({
  actionClose,
  actionDone,
  serviceId,
}) => {
  const loggedIn = localStorage.getItem("token") !== null;
  const abortRef = useRef(null);

  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(false);
  const [SESSION_ID, setSESSION_ID] = useState("");
  const [SESSION_NAME, setSESSION_NAME] = useState("");
  const [SESSION_START_DATE, setSessionStartDate] = useState("");
  const [StudentList, setStudentList] = useState([]);

  useEffect(() => {
    const session = SessionManager.getCurrentSession()?.[0];
    if (session) {
      setSESSION_ID(session.session_id || "");
      setSESSION_NAME(session.session_name || "");
      setSessionStartDate(session.start_date || "");
    }
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, []);

  const handleClose = useCallback(() => {
    setShow(false);
    actionClose();
  }, [actionClose]);

  const handleSelectedStudent = useCallback(
    (student_id, selected_item) => {
      if (selected_item.service_status === "Granted") {
        myToast.notify_warning("Already Granted");
        return;
      }
      const resolvedStartDate =
        SESSION_START_DATE ||
        SessionManager.getCurrentSession()?.[0]?.start_date ||
        localStorage.getItem("START_DATE") ||
        "";
      actionDone(
        student_id,
        selected_item,
        SESSION_ID,
        SESSION_NAME,
        resolvedStartDate
      );
    },
    [SESSION_START_DATE, SESSION_ID, SESSION_NAME, actionDone]
  );

  const getStudentList = useCallback(
    (class_id, section_id, session_id) => {
      if (abortRef.current) abortRef.current.abort();
      const controller = new AbortController();
      abortRef.current = controller;

      setLoading(true);
      setStudentList([]);

      axios
        .get(`${API_BASE}getServiceRecepientStudent.php`, {
          params: {
            school_code: SessionManager.getSchoolCode(),
            class_id,
            section_id,
            service_id: serviceId,
            session_id,
          },
          signal: controller.signal,
        })
        .then((res) => res.data)
        .then((response) => {
          if (controller.signal.aborted) return;
          setLoading(false);
          if (response.api_status === "OK") {
            setStudentList(response.data || []);
          } else {
            myToast.notify_warning(response.api_remark);
          }
        })
        .catch((error) => {
          if (
            axios.isCancel?.(error) ||
            error?.name === "CanceledError" ||
            error?.code === "ERR_CANCELED"
          ) {
            return;
          }
          setLoading(false);
          console.error("Error fetching student list:", error);
        });
    },
    [serviceId]
  );

  const CallBackClassSelect = useCallback(
    (
      class_id,
      section_id,
      session_id,
      _selected_position,
      _class_name,
      _section_name,
      session_name,
      start_date
    ) => {
      setSESSION_ID(session_id);
      setSESSION_NAME(session_name);
      setSessionStartDate(
        start_date ||
          SessionManager.getCurrentSession()?.[0]?.start_date ||
          ""
      );
      getStudentList(class_id, section_id, session_id);
    },
    [getStudentList]
  );

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <>
      <style>
        {`
          .modal-content {
            border-radius: 16px !important;
            border: none !important;
            overflow: hidden !important;
          }
          .modal-header {
            border-radius: 16px 16px 0 0 !important;
            border: none !important;
          }
          .modal-body {
            border-radius: 0 0 16px 16px !important;
            border: none !important;
          }
        `}
      </style>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        style={{ opacity: 1 }}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modern-modal"
      >
      <Modal.Header
        closeButton
        style={{
          background: `linear-gradient(135deg, ${COLORS.primary_color || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
          color: COLORS.white,
          border: "none",
          borderRadius: "16px 16px 0 0",
          padding: "20px 24px"
        }}
      >
        <Modal.Title 
          id="contained-modal-title-vcenter" 
          style={{
            fontSize: "20px",
            fontWeight: "700",
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: "12px"
          }}
        >
          <div style={{
            width: "40px",
            height: "40px",
            borderRadius: "10px",
            background: "rgba(255, 255, 255, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(10px)"
          }}>
            <i className="fa fa-user-graduate" style={{ fontSize: "20px" }}></i>
          </div>
          Select Student
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{
        padding: "24px",
        background: "#f8fafc",
        borderRadius: "0 0 16px 16px",
        border: "none"
      }}>
        <div>
          {loading && (
            <div style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255, 255, 255, 0.9)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              borderRadius: "16px"
            }}>
              <MyLoader />
            </div>
          )}
          
          <div style={{ marginBottom: "24px" }}>
            <SelectClass action={CallBackClassSelect} selected_position="0" />
          </div>
          
          {StudentList.length === 0 && !loading ? (
            <div style={{
              textAlign: "center",
              padding: "60px 20px",
              background: "white",
              borderRadius: "12px",
              border: "2px dashed #e2e8f0"
            }}>
              <div style={{
                width: "80px",
                height: "80px",
                borderRadius: "20px",
                background: `linear-gradient(135deg, ${(COLORS.primary_color || "#3b82f6")}20 0%, ${(COLORS.primary_color_shade4 || "#2563eb")}10 100%)`,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "20px"
              }}>
                <i className="fa fa-user-graduate" style={{ fontSize: "40px", color: COLORS.primary_color || "#3b82f6", opacity: 0.6 }}></i>
              </div>
              <p style={{ fontSize: "18px", fontWeight: "700", marginBottom: "10px", color: "#374151" }}>
                No Students Found
              </p>
              <p style={{ fontSize: "14px", color: "#6b7280" }}>
                Please select a class to view students.
              </p>
            </div>
          ) : (
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
              gap: "20px"
            }}>
              {StudentList.map((item) => (
                <div key={item.student_enrollment_no || item.student_id}>
                  <div
                    onClick={() =>
                      handleSelectedStudent(item.student_enrollment_no, item)
                    }
                    style={{
                      background: "white",
                      borderRadius: "16px",
                      padding: "12px",
                      border: "2px solid #e5e7eb",
                      cursor: "pointer",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                      position: "relative",
                      overflow: "hidden"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow = "0 12px 24px rgba(59, 130, 246, 0.15)";
                      e.currentTarget.style.borderColor = COLORS.primary_color || "#3b82f6";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.08)";
                      e.currentTarget.style.borderColor = "#e5e7eb";
                    }}
                  >
                    {/* Student Content */}
                    <div style={{ display: "flex", gap: "12px", alignItems: "center", flex: 1 }}>
                      {/* Student Photo */}
                      <div style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "14px",
                        background: `linear-gradient(135deg, ${COLORS.primary_color || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        flexShrink: 0,
                        boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)"
                      }}>
                        {item.student_img_path ? (
                          <img
                            src={item.student_img_path}
                            alt={item.stu_name || "Student"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover"
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.parentElement.innerHTML = `<i class="fa fa-user" style="font-size: 32px; color: white;"></i>`;
                            }}
                          />
                        ) : (
                          <i className="fa fa-user" style={{ fontSize: "32px", color: "white" }}></i>
                        )}
                      </div>

                      {/* Student Details */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <h5 style={{
                          margin: "0 0 6px 0",
                          fontSize: "15px",
                          fontWeight: "700",
                          color: "#111827",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}>
                          {item.stu_name || "N/A"}
                        </h5>
                        
                        <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                          <p style={{
                            margin: 0,
                            fontSize: "13px",
                            color: "#6b7280",
                            fontWeight: "500"
                          }}>
                            <span style={{ fontWeight: "600", color: "#374151" }}>Father:</span> {item.father_name || "N/A"}
                          </p>
                          <p style={{
                            margin: 0,
                            fontSize: "13px",
                            color: "#6b7280",
                            fontWeight: "500"
                          }}>
                            <span style={{ fontWeight: "600", color: "#374151" }}>Enrollment:</span> {item.student_enrollment_no || "N/A"}
                          </p>
                          <p style={{
                            margin: 0,
                            fontSize: "12px",
                            color: "#9ca3af"
                          }}>
                            <span style={{ fontWeight: "600", color: "#6b7280" }}>Village:</span> {item.village_town || "N/A"}
                          </p>
                        </div>
                      </div>

                      {/* Right Section: Status Badge, Roll Number & Class */}
                      <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "8px",
                        flexShrink: 0,
                        minWidth: "100px"
                      }}>
                        {/* Status Badge */}
                        <div style={{
                          padding: "4px 10px",
                          borderRadius: "16px",
                          fontSize: "10px",
                          fontWeight: "700",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          background: item.service_status === "Granted"
                            ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                            : "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                          color: "white",
                          boxShadow: item.service_status === "Granted"
                            ? "0 4px 12px rgba(245, 158, 11, 0.3)"
                            : "0 4px 12px rgba(16, 185, 129, 0.3)",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px"
                        }}>
                          {item.service_status === "Granted" && (
                            <i className="fa fa-check-circle" style={{ fontSize: "10px" }}></i>
                          )}
                          {item.service_status === "Granted" ? "Granted" : "Available"}
                        </div>

                        {/* Roll Number */}
                        <div style={{
                          width: "45px",
                          height: "45px",
                          borderRadius: "10px",
                          background: `linear-gradient(135deg, ${COLORS.primary_color || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "700",
                          boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)"
                        }}>
                          {item.class?.[0]?.student_roll_no || "N/A"}
                        </div>

                        {/* Class Info */}
                        <div style={{
                          textAlign: "center",
                          fontSize: "11px",
                          fontWeight: "600",
                          color: "#374151",
                          maxWidth: "90px"
                        }}>
                          Class: {item.class?.[0]?.section_id === "No"
                            ? item.class?.[0]?.class_name || "N/A"
                            : `${item.class?.[0]?.class_name || "N/A"}:${item.class?.[0]?.section_name || "N/A"}`}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Modal.Body>
      </Modal>
    </>
  );
};

export default MdlSelectSingleServiceStudent;
